import script from "./dialog-request-config.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog-request-config.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__